import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import axios from "axios";
import { setupAPI } from "@/utils/api";
import * as Sentry from "@sentry/react";
import "./index.css";

if (import.meta.env.VITE_APP_MOCK_DATA === "ENABLED") {
  const { worker } = await import("./mocks/browser");
  worker.start();
}

// Setup sentry
Sentry.init({
  enabled: false,
  dsn: import.meta.env.VITE_APP_SENTRY_DSN,
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      // unblock: [".sentry-unblock, [data-sentry-unblock]"],
      // unmask: [".sentry-unmask, [data-sentry-unmask]"],
      maskAllText: false,
      blockAllMedia: false,
    }),
    // Sentry.feedbackIntegration({
    //   showBranding: false,
    //   colorScheme: "system",
    //   triggerLabel: "Feedback",
    //   formTitle: "Send us feedback",
    //   submitButtonLabel: "Send Feedback",
    //   messagePlaceholder: "What's the feedback? What did you expect?",
    //   isEmailRequired: true,
    //   themeLight: {
    //     background: colors.neutral[50],
    //     accentBackground: colors.lime[500],
    //     accentForeground: colors.white,
    //   },
    //   themeDark: {
    //     background: colors.neutral[950],
    //     accentBackground: colors.lime[700],
    //     accentForeground: colors.white,
    //   },
    // }),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", import.meta.env.VITE_APP_API_URL],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// Setup axios bearer token when user is authenticated
setupAPI(axios);

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
